import { Editor } from 'react-draft-wysiwyg';
import { makeStyles } from '@material-ui/core';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, Modifier } from 'draft-js';

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100% !important',
    height: '100% !important',
    display: 'block !important',
  },
  editor: ({ fontSize }) => ({
    width: '100%',
    height: '20rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: fontSize,
    color: '#2e4469',
    '& .public-DraftStyleDefault-block': {
      margin: 'unset',
    },
    '& .DraftEditor-root': {
      height: '100%',
    },
  }),
  link: {
    '& .rdw-link-modal-target-option': {
      display: 'none',
    },
  },
}));

const CustomCheckbox = (props) => {
  const addCustomCheckbox = () => {
    console.log('props', props);
    const { editorState, onChange } = props;
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      '⭐',
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, 'insert-characters'));
  };

  return (
    <button key="customCheckbox" onClick={addCustomCheckbox}>
      Checkbox
    </button>
  );
};

const RichText = ({ value, onChange, fontSize = '1rem', disabled = false }) => {
  const classes = useStyles({ fontSize });

  const onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const text = contentState.getPlainText();

    // 检查字数是否超过上限
    if (text.length <= 3000) {
      onChange(editorState);
    } else {
      onChange(value);
    }
  };

  return (
    <Editor
      editorState={value}
      wrapperClassName={classes.wrapper}
      editorClassName={classes.editor}
      onEditorStateChange={onEditorStateChange}
      toolbar={{
        options: [
          'inline',
          // 'list'
        ],
      }}
      readOnly={disabled}
      toolbarHidden={disabled ? true : false}
    />
  );
};

export default RichText;
